import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { removeLoadingKey } from '../../helpers/common';

export const BalanceSheetLoadingKeys = {
    getBalanceSheetData: "GET_BALANCE_SHEET_DATA",
}

const initialState = {
    balanceSheetData: null,
    loadingKeys: [],
    loading: false,
    error: null,
}

export const getBalanceSheetData = createAsyncThunk(
  'balanceSheet/getBalanceSheetData',
  async ({
    startMonth,
    endMonth,
    valuesType,
    compareType,
  }, { rejectWithValue }) => {
    try {
      const params = {
        startMonth,
        endMonth,
        valuesType,
        compareType,
      };
      
      const { data } = await axios.get(`/api/v1/balance-sheet/data`, { params });
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response.data.errors || error.response.data.error)
      }
    }
  }
)

export const balanceSheetSlice = createSlice({
  name: 'balanceSheet',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(getBalanceSheetData.pending, (state) => {
            state.loading = true
            state.loadingKeys = [...state.loadingKeys, BalanceSheetLoadingKeys.getBalanceSheetData]
        })
        .addCase(getBalanceSheetData.fulfilled, (state, action) => {
            state.loading = false
            state.balanceSheetData = action.payload;
            state.error = null;
            state.loadingKeys = removeLoadingKey(BalanceSheetLoadingKeys.getBalanceSheetData, state.loadingKeys)
        })
        .addCase(getBalanceSheetData.rejected, (state, action) => {
            state.loading = false
            state.balanceSheetData = null;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(BalanceSheetLoadingKeys.getBalanceSheetData, state.loadingKeys)
        })
  }
})

export const {} = balanceSheetSlice.actions;

export default balanceSheetSlice.reducer;
